<style scoped lang="scss">
.state {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
}

._printContent /deep/ .el-form-item__label {
  text-align: right;
  vertical-align: middle;
  font-size: 22px;
  color: black;
  padding: 0 10px 0 0;
  box-sizing: border-box;
  font-family: '微软雅黑';
}

._printContent /deep/ .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: black;
  display: inline-block;
  font-size: 22px;
  outline: none;
  padding: 0 10px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 130px;
  line-height: 25px;
  height: 25px;
  font-family: '微软雅黑';
}

.custom-input-width /deep/ .el-input__inner {
  width: 90px;
}

._printContent /deep/ .el-form-item--mini.el-form-item {
  margin-bottom: 8px;
  line-height: 25px;
}

._printContent /deep/ .el-date-editor,
form .el-input,
form .el-select,
form .el-textarea {
  min-width: 130px;
  width: 100%;
}

._printContent /deep/ .el-input {
  width: 130px;
}

._printContent_long /deep/ .el-input {
  width: 395px;
}

._printContent_long /deep/ .el-input__inner {
  width: 395px;
  line-height: 25px;
  height: 25px;
  font-size: 22px;
  font-family: '微软雅黑';
  color: black;
  background-color: #fff;
  padding: 0 10px;
}

.printFontFamily {
  font-family: '微软雅黑';
}
</style>
<style>
.weier-dialog .el-dialog {
  .el-dialog__body {
    max-height: none;
  }
}

.standard-print-dialog .el-dialog {
  .el-dialog__body {
    max-height: none;
  }
}
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/production/wo/page" getKey="rows" :columns="columns" :isExpand="true">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('ERPgongdanhao')">
            <el-input v-model="yt.conditions.erpNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIdList"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('mujumingcheng')">
            <yi_cross_select multiple :component="'web_base_mould_list'" :ids.sync="yt.conditions.mouldIdList"></yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIdList"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('gongdanzhuangtai')">
            <yi_dictionary_select :max="8" multiple :type="'PRODUCTION_WO_STATUS'" :ids.sync="yt.conditions.statusList"></yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('jihuakaishishijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.planStartTimeStart" :end.sync="yt.conditions.planStartTimeEnd"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('jihuawanchengshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.planEndTimeStart" :end.sync="yt.conditions.planEndTimeEnd"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('shijiwanchengshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.actualEndTimeStart" :end.sync="yt.conditions.actualEndTimeEnd"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('guishuchejian')">
            <yi_data_select :max="1" :type="'organization'" :ids.sync="yt.conditions.orgId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('erpwuliaobianma')">
            <el-input v-model="yt.conditions.erpMaterialCode"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain>
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ statusList: ['2', '3', '4', '5'], orderBy: 'planStartTime,equipmentId asc' })">
              {{ $t('chongzhi') }}
            </el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
            <el-button size="mini" @click="show = !show" type="primary" v-if="utils.checkPower('web_production_management_work_order_execution_adjust')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-批量调整' } }">
              {{ $t('piliangtiaozheng') }}
            </el-button>
            <el-button size="mini" @click="yt.showEditDialog('danjitiaozheng', null, '80%')" type="primary" v-if="utils.checkPower('web_production_management_work_order_execution_single_adjust_button')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-单机调整' } }">
              {{ $t('danjitiaozheng') }}
            </el-button>
            <el-button size="mini" @click="syncWoReportByApi()" type="primary" :loading="zhongshuoSapLoading" v-if="utils.checkPower('web_production_management_work_order_execution_zhongshuo_call_sap_report')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-调用SAP报工接口' } }">
              {{ $t('diaoyongSAPBaogongjiekou') }}
            </el-button>
            <el-button size="mini" @click="
              yt.showEditDialog('piliangdiaobo', null, 'w1');
            resetAdapData();
            " type="primary" v-if="utils.checkPower('web_production_management_work_order_execution_batch_allot')">
              {{ $t('piliangdiaobo') }}
            </el-button>

            <el-button size="mini" @click="runSyncQunlongWorkOrdersJob" type="primary" v-if="utils.checkPower('web_production_management_work_order_run_async_work_orders_job_ql')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-同步派工单' } }">
              {{ $t('tongbupaigongdan') }}
            </el-button>
            <el-button v-if="utils.checkPower('web_order_management_production_plan_batchImportScheduling_ql')" style="margin-left: 10px;" size="mini" @click="batchImportSchedulingShow = !batchImportSchedulingShow" plain>
              {{ $t('piliangdaorupaichan') }}
            </el-button>
            <el-button @click="runSyncWorkOrdersJobRetry" v-if="utils.checkPower('web_production_management_work_order_run_async_work_orders_job_ql')" size="mini" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-修复数据' } }">
              {{ $t('xiufushuju') }}
            </el-button>
            <el-button :loading="jinlingReportLoading" @click="runJinlingAutoWorkOrdersJobRetry" v-if="utils.checkPower('web_production_management_work_order_execution_jinling_kingdee_report')" size="mini" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-金羚自动报工接口' } }">
              {{ $t('diaoyongjindiebaogongjiekou(jinling)') }}
            </el-button>
            <el-button v-if="utils.checkPower('web_production_management_work_order_execution_batch_close')" style="margin-left: 10px;" size="mini" @click="batchCloseShow = !batchCloseShow" type="primary">
              {{ $t('piliangguanbi') }}
            </el-button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <div class="state">
          <div class="state">
            <span style="width: 12px;height: 12px;border-radius: 50%;background-color: #67C23A;"></span>
            <span style="margin-left: 5px; font-size:12px">{{ $t('zhuchanpin') }}</span>
          </div>
          <div class="state" style="margin-left: 32px;">
            <span style="width: 12px;height: 12px;border-radius: 50%;background-color: #F0C78A;"></span>
            <span style="margin-left: 5px;font-size:12px">{{ $t('fuchanpin') }}</span>
          </div>
        </div>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" :loading="exportLoading" @click="exportExcel()" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-导出' } }"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>

      <template #shengchangongdanhao="scope">
        <div style="display: flex;flex-wrap: nowrap;justify-content: flex-start;align-items: center;">
          <div v-if="scope.row.parentId == null" style="float:left;width: 8px;height: 8px;border-radius: 50%;background-color: #67C23A;"></div>
          <div v-if="!(scope.row.parentId == null)" style="float:left;width: 8px;height: 8px;border-radius: 50%;background-color: #F0C78A;"></div>
          <span style="margin-left: 10px;">{{ scope.row.no }}</span>
        </div>
      </template>
      <template #wangongyuceshijian="scope">
        <div style="display: flex;flex-wrap: nowrap;justify-content: flex-start;align-items: center;">
          <div v-if="scope.row.status == 6"></div>
          <div v-else>{{ scope.row.preFinishTime | time }}</div>
        </div>
      </template>
      <!-- 工艺指南编码 -->
      <template #gongyizhinanbianma="scope">
        <span>{{ scope.row.woProcedureList | getCode }}</span>
      </template>
      <template #expand="scope">
        <sub_list :sub="scope.row.woProcedureList" :all="scope.row" :status="scope.row.status" :equipmentId="scope.row.equipmentId"></sub_list>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('gongdanBOM', scope.row, 'w2')" v-if="utils.checkPower('web_production_management_wo_bom_page')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-工单BOM' } }">
              {{ $t('gongdanBOM') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="utils.checkPower('web_production_management_custom_wo_close') && (scope.row.status == 1 || scope.row.status == 3 || scope.row.status == 4 || scope.row.status == 2)">
            <el-popconfirm :title="$t('shifouguanbigongdan')" @confirm="close(scope.row)">
              <el-button type="text" class="font-color-danger" :loading="loading" slot="reference">{{ $t('guanbi') }} </el-button>
            </el-popconfirm>
          </el-col>
          <!-- 状态  1新建、2发放、3生产中、4暂停、5首工序完工、6完工、7关闭、8已调拨 -->
          <el-col :span="0.1">
            <el-button :loading="loading" v-if="(scope.row.status == 2 || scope.row.status == 4) && scope.row.parentId == null && utils.checkPower('web_production_management_wo_start')" type="text" @click="woCheck(scope.row)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-开始' } }">{{ $t('kaishi') }} </el-button>
          </el-col>
          <el-col :span="0.1"><!-- 副工单开始 -->
            <el-button :loading="loading" v-if="scope.row.status == 4 && scope.row.parentId != null && scope.row.parentStatus == 6 && utils.checkPower('web_production_management_child_wo_start')" type="text" @click="childWoCheck(scope.row)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-副工单开始' } }">{{ $t('kaishi') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="scope.row.status == 3 && scope.row.parentId == null && utils.checkPower('web_production_management_wo_stop')" type="text" :loading="scope.row.stopLoading" @click="stop(scope.row)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-暂停' } }">
              {{ $t('zanting') }}
            </el-button>
          </el-col>
          <el-col :span="0.1"><!-- 副工单暂停 -->
            <el-button v-if="scope.row.status == 3 && scope.row.parentId != null && scope.row.parentStatus == 6 && utils.checkPower('web_production_management_child_wo_stop')" type="text" :loading="scope.row.stopLoading" @click="childStop(scope.row)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-副工单暂停' } }">
              {{ $t('zanting') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="utils.checkPower('web_production_management_work_order_execution_get_report_record') && (scope.row.status == 3 || scope.row.status == 4 || scope.row.status == 6 || scope.row.status == 5 || scope.row.status == 7 || scope.row.status == 8)" type="text" @click="yt.showEditDialog('baogongjilu', scope.row, 'w2')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-报工记录' } }">{{ $t('baogongjilu') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="(scope.row.status == 4 || scope.row.status == 2) && scope.row.parentId == null && utils.checkPower('web_production_management_wo_allot')" type="text" @click="allot(scope.row)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-调拨' } }">
              {{ $t('diaobo') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="(scope.row.status == 4 || scope.row.status == 2 || scope.row.status == 3) && scope.row.parentId == null && scope.row.woProcedureList && scope.row.woProcedureList.length === 1 && utils.checkPower('web_production_management_wo_split')" type="text" @click="yt.showEditDialog('chaidan', scope.row, 'w1', beforeShowSplitDialog)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-拆单' } }">
              {{ $t('chaidan') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="utils.checkPower('web_production_management_work_order_execution_get_change_cavity') && (scope.row.status == 4 || scope.row.status == 2)" type="text" @click="modify(scope.row)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-修改模腔数' } }">
              {{ $t('xiugaimoqiangshu') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button :loading="loading" v-if="utils.checkPower('web_production_management_work_order_execution_get_urgent') && (scope.row.status == 1 || scope.row.status == 2 || scope.row.status == 3 || scope.row.status == 4 || scope.row.status == 5) && (scope.row.urgent == null || scope.row.urgent == false)" type="text" @click="urgent(scope.row)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-加急' } }">
              {{ $t('jiaji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button :loading="loading" v-if="utils.checkPower('web_production_management_work_order_execution_get_urgent') && (scope.row.status == 1 || scope.row.status == 2 || scope.row.status == 3 || scope.row.status == 4 || scope.row.status == 5) && scope.row.urgent == true" type="text" @click="cancelUrgent(scope.row)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-取消加急' } }">
              {{ $t('quxiaojiaji') }}
            </el-button>
          </el-col>
          <!-- 沃德打印标签 -->
          <el-col :span="0.1">
            <el-button v-if="utils.checkPower('web_production_management_wo_printLabel')" type="text" @click="printLabel(scope.row)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-沃德打印标签' } }">
              {{ $t('dayinbiaoqian') }}
            </el-button>
          </el-col>
          <!-- 瑞柯打印标签 -->
          <el-col :span="0.1">
            <el-button v-if="utils.checkPower('web_production_management_wo_ruike_printLabel')" type="text" @click="printRuikeLabel(scope.row)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-瑞科打印标签' } }">
              {{ $t('dayinbiaoqian') }}
            </el-button>
          </el-col>
          <!-- 打印标签(标准) -->
          <el-col v-if="utils.checkPower('web_production_management_wo_standard_printLabel')" :span="0.1" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-打印标签' } }">
            <el-button type="text" @click="standardPrintLabel(scope.row)">
              {{ $t('dayinbiaoqian(biaozhun)') }}
            </el-button>
          </el-col>
          <!-- 打印标签(维尔) -->
          <el-col v-if="utils.checkPower('web_production_management_wo_printLabel_weier')" :span="0.1" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-维尔打印标签' } }">
            <el-button type="text" @click="weierPrintLabel(scope.row)">
              {{ $t('dayinbiaoqian(weier)') }}
            </el-button>
          </el-col>
          <!-- 打印标签(力腾辉) -->
          <el-col v-if="utils.checkPower('web_production_management_wo_printLabel_litenghui')" :span="0.1" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-力腾辉打印标签' } }">
            <el-button type="text" @click="litenghuiPrintLabel(scope.row)">
              {{ $t('dayinbiaoqian(litenghui)') }}
            </el-button>
          </el-col>
          <!-- 适配工装(维尔) -->
          <el-col v-if="utils.checkPower('web_production_management_wo_adapt_tool_weier')" :span="0.1" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-适配工装' } }">
            <el-button type="text" @click="weierAdaptTool(scope.row)">
              {{ $t('shipeigongzhuang') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('zhuangtaijilu', scope.row, 'w2')" v-if="utils.checkPower('web_production_management_work_order_execution_status_change_record')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-状态记录' } }">
              {{ $t('zhuangtaijilu') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('换模记录', scope.row, 'w2')" v-if="utils.checkPower('web_production_management_execution_jscc_change_mould_record')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-换模记录' } }">
              {{ $t('换模记录') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog v-dialog-drag :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action == 'baogongjilu'">
        <div class="dialog-scroller">
          <report :reportWork="yt.editObj" :chart="yt.editObj"></report>
        </div>
      </template>
      <template v-if="yt.editObj.action == 'gongdanBOM'">
        <div class="dialog-scroller">
          <bom :bomWork="yt.editObj"></bom>
        </div>
      </template>

      <template v-if="yt.editObj.action == 'zhuangtaijilu'">
        <div class="dialog-scroller">
          <woStatus :woInfo="yt.editObj"></woStatus>
        </div>
      </template>
      <template v-if="yt.editObj.action == '换模记录'">
        <div class="dialog-scroller" v-loading="moldChangeRecordLoading">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px;">
            <div>
              <span>{{ $t('shengchangongdanhao') }}：</span>
              <span>{{ yt.editObj.no }}</span>
            </div>
            <el-button type="primary" size="mini" @click="exportMoldChangeRecord" v-if="utils.checkPower('web_production_management_execution_jscc_change_mould_record_export')">
              {{ $t('daochu') }}
            </el-button>
          </div>
          <el-table :data="moldChangeRecordList" border style="width: 100%">
            <el-table-column prop="startTime" :label="$t('上模时间')" min-width="180">
              <template slot-scope="scope">
                {{ formatMoldChangeTime(scope.row.startTime) }}
              </template>
            </el-table-column>
            <el-table-column prop="endTime" :label="$t('下模时间')" min-width="180">
              <template slot-scope="scope">
                {{ formatMoldChangeTime(scope.row.endTime) }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
      <template v-if="yt.editObj.action == 'diaobo'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item class="noborder" :label="$t('shengchangongdanhao')" required>
            <el-input disabled v-model="yt.editObj.no"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('chanpinbianma/mingcheng')" required>
            <yi_cross_select disabled multiple :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="yt.editObj.materialId"></yi_cross_select>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('jihuashuliang')" required>
            <el-input disabled v-model="yt.editObj.planQuantity"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('shengyushengchanshuliang')">
            <el-input disabled v-model="yt.editObj.leftProductionQuantity"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mujubianhao/mingcheng')" required>
            <yi_cross_select :max="1" :selectTitle="'no,name'" :component="'web_order_management_production_plan_mold_list'" :ids.sync="yt.editObj.mouldId" :materialId="yt.editObj.materialId"></yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')" required>
            <yi_cross_select :max="1" :component="'web_production_management_work_order_execution_equipment_list'" :ids.sync="yt.editObj.equipmentId" :mouldId="yt.editObj.mouldId" :materialId="yt.editObj.materialId"></yi_cross_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <!--          id=yt.editObj.id;equipmentId=yt.editObj.equipmentId;mouldId=yt.editObj.mouldId;yt.req('POST','/web/production/wo/allot')-->
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="allocation" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action == 'chaidan'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item class="noborder" :label="$t('chanpinbianma')">
            <el-input disabled v-model="yt.editObj.material.code"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('chanpinmingcheng')">
            <el-input disabled v-model="yt.editObj.material.name"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('jihuashuliang')">
            <el-input disabled v-model="yt.editObj.planQuantity"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('shengchanshuliang')">
            <el-input disabled v-model="yt.editObj.productionQuantity"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('shengyushengchanshuliang')">
            <el-input disabled v-model="yt.editObj.leftProductionQuantity"></el-input>
          </el-form-item>
          <div style="margin-left: 80px" v-for="(item, index) in yt.editObj.quantities" :key="index">
            <el-form-item>
              <span>{{ $t('shuliang') }}</span>
              <el-input-number style="width:20%;margin-right:10px;margin-left: 10px" v-model="item.quantitiesLable" :min="1"></el-input-number>
              <i class="el-icon-delete" @click="del(index)"></i>
            </el-form-item>
          </div>
          <el-button style="margin-left: 80px" type="text" icon="el-icon-circle-plus-outline" @click="add">
            {{ $t('zengjiayitiaochaidan') }}
          </el-button>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <!--          id=yt.editObj.id;equipmentId=yt.editObj.equipmentId;mouldId=yt.editObj.mouldId;yt.req('POST','/web/production/wo/allot')-->
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="split" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!--修改模腔数-->
      <template v-if="yt.editObj.action == 'xiugaimoqiangshu'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item class="noborder" :label="$t('lilunmoqiangshu')" required>
            <el-input disabled v-model="yt.editObj.cavity"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shijimoqiangshu')" required="required" label-width="145px">
            <el-input-number v-model="yt.editObj.actualCavity" @change="cavityChange" controls-position="right" :min="1" :max="cavityValue"></el-input-number>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" :disabled="cavityDisabled" @click="yt.req('POST', '/web/production/wo/updateActualCavity')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>

      <template v-if="yt.editObj.action == 'danjitiaozheng'">
        <div class="dialog-scroller">
          <singleAdjust ref="singleAdjust" @list-change="singleAdjustListChange"></singleAdjust>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" :disabled="singleAdjustList == null || singleAdjustList.length === 0" @click="batchSetPriority" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>

      <!-- equipmentId: 8998 leftProductionQuantity: 2 materialId: 23289 mouldId: 400 planQuantity: 2 woIds: [897] -->

      <template v-if="yt.editObj.action == 'piliangdiaobo'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item class="noborder" :label="$t('shengchangongdanhao')" required>
            <yi_cross_select ref="eqCS" :beforeSave="beforeSave" multiple :selectTitle="'no'" :component="'web_production_management_work_order_execution_batch_transfer'" :ids.sync="yt.editObj.ids"></yi_cross_select>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('chanpinbianma/mingcheng')" required>
            {{ yt.editObj.materialStr }}
          </el-form-item>
          <el-form-item class="noborder" :label="$t('jihuashuliang')" required>
            <el-input disabled v-model="yt.editObj.planQuantity"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('shengyushengchanshuliang')">
            <el-input disabled v-model="yt.editObj.leftProductionQuantity"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mojubianhao/mingcheng')" required>
            <el-select :clearable="true" v-model="yt.editObj.mouldId" :placeholder="$t('qingxuanze')" @change="
              yt.editObj.equipmentId = null;
            getAdaptEquipment();
            ">
              <el-option v-for="(mould, index) in adaptMoulds" :key="mould.no" :label="mould.no + '/' + mould.name" :value="mould.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')" required>
            <el-select :disabled="yt.editObj.mouldId == null || yt.editObj.mouldId == ''" :clearable="true" v-model="yt.editObj.equipmentId" :placeholder="$t('qingxuanze')">
              <el-option v-for="(equipment, index) in adaptEqs" :key="equipment.id" :label="equipment.name" :value="equipment.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/custom/qunlong/batchAllot')" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-批量调拨' } }">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 批量调整 -->
    <batchAdjust :show.sync="show" />
    <!-- 批量导入排产 -->
    <batchImportScheduling :show.sync="batchImportSchedulingShow" />
    <!-- 打印标签(沃德) -->
    <el-dialog v-dialog-drag :show-close="true" :visible.sync="isShowPrintDialog" width="550px" append-to-body="append-to-body" :before-close="closePrintDialog">
      <div v-if="isShowPrintDialog" style="height: 600px;width: 510px;margin-top: 15px">
        <div id="printContent" style="margin-top: 5px" class="printFontFamily">
          <div style="display:flex;justify-content: center;">
            <div style="position: absolute;left: 30px;">
              <img style="object-fit: contain;width: 120px;height: 73px" :src="require('@@/assets/img/web/production_management/wodeLogo.png')" />
            </div>
            <div style="line-height: 60px;font-size: 22px;color: black;" class="printFontFamily">{{ $t('chanpinhegezheng') }}</div>
          </div>
          <div :inline="true" size="mini" class="dialog-scroller" style="height: 550px;">
            <div class="_printContent">
              <div style="display: flex;margin: 5px 0 10px 0;">
                <div style="width:95px;font-size: 22px;color: black;flex-shrink: 0;">{{ $t('chanpinbianma') }}</div>
                <div style="font-size: 22px;margin-left: 10px;color: black;flex:1">{{ printObj.material.code }}</div>
              </div>
              <div style="display: flex;margin: 10px 0;">
                <div style="width:95px;font-size: 22px;color: black;flex-shrink: 0;">{{ $t('chanpinmingcheng') }}</div>
                <span style="font-size: 22px;margin-left: 10px;color: black;flex:1">{{ printObj.material.name }}</span>
              </div>
              <div style="display: flex;margin: 10px 0;">
                <span style="width:95px;font-size: 22px;color: black;flex-shrink: 0;">{{ $t('chanpinguige') }}</span>
                <span style="font-size: 22px;margin-left: 10px;color: black;flex:1">{{ printObj.material.spec }}</span>
              </div>
            </div>
            <div class="_printContent">
              <div style="display: flex;margin: 0 0 10px 0;">
                <div style="width:90px;font-size: 22px;color: black;flex-shrink: 0;">{{ $t('yanse') + $t('caizhi') }}</div>
                <span style="width:100%;font-size: 22px;margin-left: 10px;color: black;">{{ printObj.material.color }}&nbsp;{{ printObj.material.ingredient }}</span>
              </div>
              <div style="display: flex;margin: 0 0 10px 0;">
                <div style="width:90px;font-size: 22px;color: black;">{{ $t('baozhuangshuliang') }}</div>
                <el-input v-if="!isPrint" class="custom-input-width" style="width:90px;margin-left: 10px;" v-model="printObj.planQuantity"></el-input>
                <div v-if="isPrint" style="font-size: 22px;margin-left: 10px;color: black">{{ printObj.planQuantity }} pcs</div>
                <span v-if="!isPrint" style="font-size: 22px;margin-left: 1px;color: black">pcs</span>
              </div>
              <div style="display: flex;margin: 10px 0;">
                <div style="width:90px;font-size: 22px;color: black;">{{ $t('shengchanpici') }}</div>
                <el-input v-if="!isPrint" style="margin-left: 10px;" maxlength="20" v-model="printObj.shengchanpici"></el-input>
                <div v-if="isPrint" style="font-size: 22px;margin-left: 10px;color: black">{{ printObj.shengchanpici }}</div>
              </div>
              <div style="display: flex;margin: 10px 0;">
                <div style="width:90px;font-size: 22px;color: black;">{{ $t('shengchanriqi') }}</div>
                <el-input v-if="!isPrint" style="margin-left: 10px;" maxlength="20" v-model="printObj.produceDate"></el-input>
                <div v-if="isPrint" style="font-size: 22px;margin-left: 10px;color: black">{{ printObj.produceDate }}</div>
              </div>
            </div>
            <div class="_printContent_long">
              <div style="display: flex;margin: 0 0 10px 0;">
                <div style="width:90px;font-size: 22px;color: black;">{{ $t('caozuogonghao') }}</div>
                <el-input v-if="!isPrint" style="margin-left: 10px;" maxlength="20" v-model="printObj.operator"></el-input>
                <div v-if="isPrint" style="width:395px;font-size: 22px;margin-left: 10px;color: black">{{ printObj.operator }}</div>
              </div>
            </div>
            <div class="_printContent">
              <div style="display: flex;margin: 0 0 10px 0;">
                <div style="width:90px;font-size: 22px;color: black;">{{ $t('jianyanzhuangtai') }}</div>
                <span style="font-size: 22px;margin-left: 10px;color: black;">{{ $t('hege') }}</span>
              </div>
              <div style="display: flex;margin: 0 0 10px 0;">
                <div style="width:90px;font-size: 22px;color: black;">{{ $t('jianyangonghao') }}</div>
                <el-input v-if="!isPrint" style="margin-left: 10px;" maxlength="20" v-model="printObj.inspectorNo"></el-input>
                <div v-if="isPrint" style="font-size: 22px;margin-left: 10px;color: black">{{ printObj.inspectorNo }}</div>
              </div>
            </div>
            <div v-if="isShowQrCode" style="position: absolute;right: 100px;">
              <vue-qr :text="printObj.no + '/' + printObj.material.code" :margin="0" :size="120"></vue-qr>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" style="display: block;text-align: center;">
        <div style="margin-top:10px;margin-bottom: 10px;">
          <el-checkbox v-model="isShowQrCode">{{ $t('shifouxianshierweima') }}</el-checkbox>
        </div>
        <div>
          <el-button @click="dayin()" type="primary" style="width: 130px">{{ $t('dayin') }}</el-button>
          <!-- <el-button @click="dayin2()" type="primary" style="width: 130px">{{ $t('bartender') }}</el-button> -->
        </div>
      </span>
    </el-dialog>
    <!-- 瑞柯打印标签 -->
    <el-dialog v-dialog-drag :visible.sync="isShowRuikePrintLabel" append-to-body="append-to-body" width="700px">
      <ruikePrintLabel v-if="isShowRuikePrintLabel" :ruikePrintObj="ruikePrintObj" @closeDialog="closeRuikePrintLabel"></ruikePrintLabel>
    </el-dialog>
    <!-- 标准打印标签 -->
    <el-dialog v-dialog-drag class="standard-print-dialog" :visible.sync="isShowStandardPrintLabel" append-to-body="append-to-body" width="800px">
      <standardPrintLabel v-if="isShowStandardPrintLabel" :printObj="printObj" @closeDialog="closeStandardPrintLabel"></standardPrintLabel>
    </el-dialog>
    <!-- 维尔打印标签 -->
    <el-dialog v-dialog-drag class="weier-dialog" :visible.sync="isShowWeierPrintLabel" append-to-body="append-to-body" width="800px">
      <weierPrintLabel v-if="isShowWeierPrintLabel" :printObj="printObj" @closeDialog="closeWeierPrintLabel"></weierPrintLabel>
    </el-dialog>
    <!-- 力腾辉打印标签 -->
    <el-dialog v-dialog-drag class="weier-dialog" :visible.sync="isShowLitenghuiPrintLabel" append-to-body="append-to-body" width="800px">
      <litenghuiPrintLabel v-if="isShowLitenghuiPrintLabel" :printObj="printObj" @closeDialog="closeLitenghuiPrintLabel"></litenghuiPrintLabel>
    </el-dialog>
    <!-- 适配工装(维尔) -->
    <el-dialog v-dialog-drag :title="$t('chanpinshipeigongzhuang')" :visible.sync="isShowWeierAdaptTool" append-to-body="append-to-body" width="800px">
      <div class="dialog-scroller">
        <weierAdaptTool v-if="isShowWeierAdaptTool" :material="material"></weierAdaptTool>
      </div>
    </el-dialog>
    <!-- 批量关闭 -->
    <el-dialog v-dialog-drag :visible.sync="batchCloseShow" :title="$t('piliangguanbi')" append-to-body="append-to-body" width="1000px">
      <div class="dialog-scroller">
        <batchClose :show.sync="batchCloseShow" v-if="batchCloseShow"></batchClose>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import Vue from 'vue';

import sub_list from '@@/pages/web/production_management/work_order_execution/sub/list';
import report from '@@/pages/web/production_management/work_order_execution/report';
import bom from '@@/pages/web/production_management/work_order_execution/bom';
import batchAdjust from '@@/pages/web/production_management/work_order_execution/batch_adjust';
import singleAdjust from '@@/pages/web/production_management/work_order_execution/single_adjust';
import batch_transfer from '@@/pages/web/production_management/work_order_execution/batch_transfer';
import batchImportScheduling from '@@/pages/web/order_management/production_plan/batch_import_scheduling';
import ruikePrintLabel from '@@/pages/web/production_management/work_order_execution/ruike_print_label';
import standardPrintLabel from '@@/pages/web/production_management/work_order_execution/standard_print_label';
import weierPrintLabel from '@@/pages/web/production_management/work_order_execution/weier_print_label';
import litenghuiPrintLabel from '@@/pages/web/production_management/work_order_execution/litenghui_print_label';
import weierAdaptTool from '@@/pages/web/production_management/work_order_execution/weier_adapt_tool';
import batchClose from '@@/pages/web/production_management/work_order_execution/batch_close';
import woStatus from '@@/pages/web/production_management/work_order_execution/woStatus';
import VueQr from 'vue-qr';
import html2canvas from 'html2canvas';
import print from 'print-js';
import XLSX from "xlsx";

Vue.component('web_production_management_work_order_execution_batch_transfer', batch_transfer);

export default {
  name: 'web_production_management_work_order_execution_list',
  components: {
    sub_list,
    report,
    bom,
    batchAdjust,
    singleAdjust,
    batchImportScheduling,
    ruikePrintLabel,
    standardPrintLabel,
    weierPrintLabel,
    litenghuiPrintLabel,
    weierAdaptTool,
    batchClose,
    VueQr,
    woStatus
  },
  data() {
    return {
      jinlingReportLoading: false,
      show: false,
      batchImportSchedulingShow: false,
      batchCloseShow: false,
      loading: false,
      zhongshuoSapLoading: false,
      exportLoading: false,
      cavityNumber: '',
      initialInputValue: '',
      cavityDisabled: true,
      fildIds: '',
      material: null,
      clampingtimes: null,
      isShowPrintDialog: false,
      isShowRuikePrintLabel: false,
      isShowStandardPrintLabel: false,
      isShowWeierPrintLabel: false,
      isShowLitenghuiPrintLabel: false,
      isShowWeierAdaptTool: false,
      printObj: {},
      ruikePrintObj: {},
      isShowQrCode: false,
      isPrint: false,
      singleAdjustList: [],
      moldChangeRecordList: [],
      moldChangeRecordLoading: false,
      //机模配信息
      adaptMoulds: [],
      adaptEqs: [],
      colorNoEnable: false,
      columns: [
        {
          label: 'shengchangongdanhao',
          prop: 'no',
          type: 'slot',
          sort: 'string',
          width: 250
        },
        {
          label: 'jihuadanhao',
          prop: 'plan.no',
          sort: 'string',
          width: 130
        },
        {
          label: 'kehubianma',
          prop: 'plan.wmsCustomerCode',
          sort: 'string',
          width: 130
        },
        {
          label: 'kehumingcheng',
          prop: 'plan.wmsCustomerName',
          sort: 'string',
          width: 130
        },
        {
          label: 'ERPgongdanhao',
          prop: 'erpNo',
          sort: 'string',
          width: 130
        },
        {
          label: 'gongdanzhuangtai',
          type: 'tag',
          sort: 'string',
          prop: 'status',
          width: 130,
          tags: {
            1: {
              color: '#419FFF',
              text: this.$t('xinjian')
            },
            2: {
              color: '#419FFF',
              text: this.$t('fafang')
            },
            3: {
              color: '#67C23A',
              text: this.$t('shengchanzhong')
            },
            4: {
              color: '#F56C6C',
              text: this.$t('zanting')
            },
            5: {
              color: '#67C23A',
              text: this.$t('shougongxuwangong')
            },
            6: {
              color: '#67C23A',
              text: this.$t('wangong')
            },
            7: {
              color: '#909399',
              text: this.$t('guanbi')
            },
            8: {
              color: '#E6A23C',
              text: this.$t('yidiaobo')
            }
          }
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name',
          sort: 'string',
          width: 130
        },
        {
          label: 'mujubianhao',
          prop: 'mould.no',
          sort: 'string',
          width: 130
        },
        {
          label: 'mujumingcheng',
          prop: 'mould.name',
          sort: 'string',
          width: 130
        },
        {
          label: 'shijimoqiangshu',
          prop: 'actualCavity',
          width: 130
        },
        {
          label: 'chanpinbianma',
          prop: 'material.code',
          sort: 'string',
          width: 130
        },
        {
          label: 'chanpinmingcheng',
          prop: 'material.name',
          sort: 'string',
          width: 130
        },
        {
          label: 'chanpinguige',
          prop: 'material.spec',
          sort: 'string',
          width: 130
        },
        {
          label: 'sehao',
          prop: 'plan.colorNo',
          type: 'dictionary',
          key: 'CUSTOMER_MATERIAL_COLOR_NO',
          width: 130,
          show: false
        },
        {
          label: 'jihuashuliang',
          prop: 'planQuantity',
          sort: 'number'
        },
        {
          label: 'shengchanshuliang',
          prop: 'productionQuantity',
          width: 130
        },
        {
          label: 'shengyushengchanshuliang',
          prop: 'leftProductionQuantity',
          width: 130
        },
        {
          label: 'yibaogongliangpinshu',
          prop: 'finishGoodQuantity',
          width: 130
        },

        {
          label: 'yibaogongbuliangpinshu',
          prop: 'finishBadQuantity',
          width: 130
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 180
        },
        {
          label: 'jihuakaishishijian',
          prop: 'planStartTime',
          type: 'time',
          width: 180
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: 'jihuawanchengshijian',
          prop: 'planEndTime',
          type: 'time',
          width: 180
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: 'shijikaishishijian',
          prop: 'actualStartTime',
          type: 'time',
          width: 180
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: 'shijiwanchengshijian',
          prop: 'actualEndTime',
          type: 'time',
          width: 180
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: 'biaozhunzhouqi(miao/mu)',
          prop: 'standardCycle',
          width: 130
        },
        {
          label: 'shougongxuwanchengshijian',
          prop: 'firstProcessFinishTime',
          type: 'time',
          width: 180
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: 'wangongyuceshijian',
          prop: 'preFinishTime',
          type: 'slot',
          width: 180
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: 'shengyushijian(xiaoshi)',
          prop: 'leftHours',
          width: 130
        },
        {
          label: 'gongyizhinanbianma',
          prop: 'craftGuide.code',
          // type: 'slot',
          width: 130
        },
        {
          label: 'huohao',
          prop: 'plan.articleNumber',
          width: 150
        },
        {
          label: 'shengchandingdanfenluid',
          prop: 'plan.orderEntryId',
          width: 150
        },
        {
          label: 'gongdanshunxu',
          prop: 'priority',
          width: 130
        },
        {
          label: 'guishuchejian',
          prop: 'org.name'
        },
        {
          label: 'shifoujiaji',
          prop: 'urgent',
          type: 'bool',
          iln18: ['shi', 'fou']
        },
        {
          label: 'erpwuliaobianma',
          prop: 'material.erpMaterialCode',
          width: 130
        },
        {
          label: 'beizhu',
          prop: 'remark'
          // width: 130,
        },
        {
          label: 'lilunshengchanshichang(h)',
          prop: 'standardDuration'
        },
        {
          label: 'shijishengchanshichang(h)',
          prop: 'actualDuration'
        },
        {
          label: 'shijiandachenglv(%)',
          prop: 'timeAchievementRate'
        },
        {
          label: 'yidayinshuliang',
          prop: 'printCountNum'
        },
        {
          label: 'shengyudayinshuliang',
          prop: 'leftPrintCountNum'
        },
        {
          label: 'zhichenggongyi',
          prop: 'manufacturingProcess',
          type: 'dictionary',
          key: 'MANUFACTURING_PROCESS',
          width: 130
        },
        {
          label: 'dangqianliaohao',
          prop: 'material.no',
        },
        {
          label: 'caizhi',
          prop: 'material.ingredient',
        },
        {
          label: 'yanse',
          prop: 'material.color',
        },
        {
          label: 'sefen',
          prop: 'material.colorPowder',
        },
        {
          label: 'guanbiyuanyin',
          prop: 'closeReason',
          width: 130
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 250,
          fixed: 'right'
        }
      ]
    };
  },
  filters: {
    getCode(value) {
      if (value != null) {
        return value
          .map(item => {
            return item.procedureCode;
          })
          .join(',');
      }
      return '';
    }
  },
  watch: {
    'yt.editObj.action': {
      handler(n, o) {
        if (n == 'xiugaimoqiangshu') {
          this.initialInputValue = this.yt.editObj.actualCavity;
          // console.log('this.initialInputValue', this.initialInputValue)
        }
        if (n == '换模记录' && this.yt.editObj.id) {
          this.fetchMoldChangeRecords();
        }
      },
      immediate: false,
      deep: true
    },
    cavityNumber: {
      handler(n, o) {
        if (n == this.initialInputValue) {
          this.cavityDisabled = true;
        }
      },
      immediate: false,
      deep: true
    }
  },
  computed: {
    cavityValue() {
      return this.yt.editObj.cavity;
    }
  },
  created() {
    this.getProductionConfig();
    setTimeout(() => {
      this.yt.conditions = {
        statusList: ['2', '3', '4', '5'],
        orderBy: 't.priority,t.planStartTime,t.equipmentId asc'
      };
      this.yt.get(1);
      this.utils.event_hub.$on('WEB_WORK_ORDER_EXECUTION_REFRESH', () => {
        this.yt.get();
      });
    }, 300);
  },
  destroyed() {
    // 取消对bus事件的监听
    this.utils.event_hub.$off('WEB_WORK_ORDER_EXECUTION_REFRESH');
  },
  methods: {
    // 关闭工单
    close(row) {
      this.loading = true;
      return this.http
        .post('/web/production/wo/close', row.id)
        .then(res => {
          this.yt.get(1);
          this.$message.success(this.$t(res.msg));
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 查询生产配置-启用产品色号管理
    getProductionConfig() {
      this.http.get('/web/production/config/list?type=26&status=1').then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.colorNoEnable = true;
        }
        if (this.colorNoEnable) {
          this.showColumn('sehao');
        }
      });
    },
    // 显示指定列
    showColumn(label) {
      for (let i = 0; i < this.columns.length; i++) {
        const c = this.columns[i];
        if (c.label === label) {
          c.show = true;
          break;
        }
      }
    },
    runJinlingAutoWorkOrdersJobRetry() {
      this.jinlingReportLoading = true;
      this.http.get('/custom/jinling/wo/autoWoReport')
        .then(res => {
          this.$message.success(this.$t('success'));
          this.jinlingReportLoading = false;
        })
        .catch(err => {
          this.jinlingReportLoading = false;
          this.$message.error(this.$t(err));
        });
    },
    runSyncWorkOrdersJobRetry() {
      this.$confirm(this.$t('shifoulijikaishixiufushuju'), this.$t('WARNING'), {
        confirmButtonText: this.$t('queding'),
        cancelButtonText: this.$t('quxiao'),
        confirmButtonClass: 'el-button--danger',
        type: 'warning'
      })
        .then(() => {
          this.http
            .post('/custom/qunlong/work/orders/runSyncWorkOrdersJobRetry')
            .then(res => {
              this.$message.success(this.$t('kaishixiufushuju'));
            })
            .catch(err => {
              this.$message.error(this.$t(err));
            });
        })
        .catch(e => {
          this.$message.info(this.$t('yiquxiao'));
        });
    },
    cavityChange(value) {
      // console.log('value',this.initialInputValue);
      if (value) {
        this.cavityDisabled = false;
      }
      this.cavityNumber = value;
    },
    // beforeGet(params) {
    //   params['orderBy'] = 'planStartTime,equipmentId asc'
    //   // params['statusList'] = ['2','3','4','5']
    //   return params
    // },
    async allocation() {
      let params = {
        id: this.yt.editObj.id,
        equipmentId: this.yt.editObj.equipmentId,
        mouldId: this.yt.editObj.mouldId
      };
      return await this.http
        .post('/web/production/wo/allot', params)
        .then(res => {
          this.yt.isShowEditDialog = false;
          this.yt.get();
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    woCheck(row) {
      let params = {};
      params.id = row.id;
      this.loading = true;
      this.http
        .post('/web/production/wo/check', params)
        .then(res => {
          this.loading = false;
          if (res.data == true) {
            this.start(row);
          } else {
            this.$confirm(this.$t('cunzaizantinggongdandetishi'), this.$t('tishi'), {
              confirmButtonText: this.$t('rengjixukaishi'),
              cancelButtonText: this.$t('quxiaokaishi'),
              type: 'warning'
            })
              .then(() => {
                this.start(row);
              })
              .catch(() => { });
          }
        })
        .catch(err => {
          this.loading = false;
          this.utils.errorMessage(err);
        });
    },
    start(row) {
      return this.http
        .post('/web/production/wo/start', row.id)
        .then(res => {
          this.yt.get();
          this.$message.success(this.$t(res.msg));
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    stop(row) {
      this.$set(row, 'stopLoading', true);

      this.http
        .post('/web/production/wo/stopCheck', row.id)
        .then(res => {
          if (res.data && res.data > 0) {
            this.$confirm(this.$t('dqkhmcs') + res.data + ',' + this.$t('qqrsfjxzt') + '?', this.$t('tishi'), {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              return this.http
                .post('/web/production/wo/stop', row.id)
                .then(res => {
                  this.yt.get();
                  this.$message.success(this.$t(res.msg));
                })
                .catch(error => {
                  this.$message.error(this.$t(error));
                });
            });
          } else {
            return this.http
              .post('/web/production/wo/stop', row.id)
              .then(res => {
                this.yt.get();
                this.$message.success(this.$t(res.msg));
              })
              .catch(error => {
                this.$message.error(this.$t(error));
              });
          }
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        })
        .finally(() => {
          this.$set(row, 'stopLoading', false);
        });
    },
    allot(row) {
      this.yt.showEditDialog('diaobo', row, 'w1');
    },
    modify(row) {
      this.yt.showEditDialog('xiugaimoqiangshu', row, 'w1');
    },
    beforeShowSplitDialog(editObj) {
      if (editObj.action === 'chaidan') {
        editObj.quantities = [
          {
            quantitiesLable: ''
          }
        ];
      }
      return editObj;
    },
    // 添加按钮
    add() {
      // this.array.push(1)  //通过添加array的值，增加input的个数
      this.yt.editObj.quantities.push({
        quantitiesLable: ''
      });
    },
    del(key) {
      this.yt.editObj.quantities = this.yt.editObj.quantities.filter((item, index) => {
        return index !== key;
      });
    },
    split() {
      let result = this.yt.editObj.quantities.filter(item => item.quantitiesLable > 0).map(item => parseInt(item.quantitiesLable));
      let data = {
        woId: this.yt.editObj.id,
        quantities: result
      };
      return this.http
        .post('/web/production/wo/split', data)
        .then(res => {
          this.yt.isShowEditDialog = false;
          this.yt.get();
          this.$message.success(this.$t(res.msg));
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    //导出
    exportExcel() {
      this.exportLoading = true;
      //查询表格数据
      this.http.get('/web/production/wo/page?pageNum=1&pageSize=9999', { params: { ...this.yt.conditions } }).then(res => {
        // 获取当前显示的列（排除操作列）
        const visibleColumns = this.columns.filter(col =>
          col.type !== 'slot' &&
          col.label !== 'caozuo' &&
          this.yt.showColumns.includes(col.label)
        );

        // 生成表头
        let tableFirst = visibleColumns.map(col => this.$t(col.label));
        let tableData = [];
        tableData.push(tableFirst);

        let listData = res.data.rows;
        for (let i = 0; i < listData.length; i++) {
          let dataArr = [];
          let item = listData[i];

          // 根据列配置动态生成数据
          visibleColumns.forEach((col, index) => {
            dataArr[index] = this.getColumnValue(item, col);
          });

          tableData.push(dataArr);
        }

        const worksheet = XLSX.utils.aoa_to_sheet(tableData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        XLSX.writeFile(workbook, `工单执行_${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
      }).finally(() => {
        this.exportLoading = false;
      });
    },
    // 获取换模记录
    fetchMoldChangeRecords() {
      this.moldChangeRecordList = [];
      this.moldChangeRecordLoading = true;
      this.http
        .get('/custom/jschicheng/change/mould/record/page', {
          params: {
            pageNum: 1,
            pageSize: 9999,
            woId: this.yt.editObj.id
          }
        })
        .then(res => {
          this.moldChangeRecordList = res.data.rows || [];
        })
        .catch(() => {
          this.moldChangeRecordList = [];
        })
        .finally(() => {
          this.moldChangeRecordLoading = false;
        });
    },
    // 格式化换模时间
    formatMoldChangeTime(val) {
      if (!val) return '-';
      const d = typeof val === 'number' && val < 1e12 ? this.dayjs.unix(val) : this.dayjs(val);
      return d.isValid() ? d.format('YYYY-MM-DD HH:mm:ss') : String(val);
    },
    // 导出换模记录（前端导出）
    exportMoldChangeRecord() {
      const tableData = [
        [this.$t('上模时间'), this.$t('下模时间')],
        ...this.moldChangeRecordList.map(row => [
          this.formatMoldChangeTime(row.startTime),
          this.formatMoldChangeTime(row.endTime)
        ])
      ];
      const worksheet = XLSX.utils.aoa_to_sheet(tableData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      XLSX.writeFile(workbook, `换模记录_${this.yt.editObj.no}_${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
    },
    // 获取列值
    getColumnValue(item, col) {
      const prop = col.prop;
      let value = '';

      // 处理嵌套属性
      if (prop && prop.includes('.')) {
        const props = prop.split('.');
        let temp = item;
        for (let p of props) {
          temp = temp ? temp[p] : null;
        }
        value = temp;
      } else if (prop) {
        value = item[prop];
      }

      // 根据列类型处理数据
      switch (col.type) {
        case 'time':
          return value ? this.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        case 'tag':
          if (col.label === 'gongdanzhuangtai') {
            return this.getStatusText(value);
          }
          return value || '';
        case 'dictionary':
          if (col.key && this.store.state.dictJson[col.key] && this.store.state.dictJson[col.key][value]) {
            return this.$t(this.store.state.dictJson[col.key][value]);
          }
          return value || '';
        case 'bool':
          return value ? this.$t('shi') : this.$t('fou');
        default:
          return value || '';
      }
    },
    // 获取工单状态文本
    getStatusText(status) {
      const statusMap = {
        1: this.$t('xinjian'),
        2: this.$t('fafang'),
        3: this.$t('shengchanzhong'),
        4: this.$t('zanting'),
        5: this.$t('shougongxuwangong'),
        6: this.$t('wangong'),
        7: this.$t('guanbi'),
        8: this.$t('yidiaobo')
      };
      return statusMap[status] || '';
    },
    // 获取制造工艺文本
    getManufacturingProcessText(process) {
      if (!process) return '';
      return this.$t(this.store.state.dictJson['MANUFACTURING_PROCESS'][process]) || process;
    },
    // 重置
    clear() {
      this.yt.conditions = {
        createTimeStart: this.begin(),
        createTimeEnd: this.end()
      };
      this.yt.list = [];
    },
    singleAdjustListChange(list) {
      this.singleAdjustList = list;
    },
    batchSetPriority() {
      let list = this.$refs.singleAdjust.yt.list;
      if (list == null || list.length === 0) {
        return;
      }
      this.yt.editObj.loading = true;
      // let params = {};
      // list.forEach((l) => {
      //   params[l.id] = l.priority;
      // });

      this.http
        .post('/custom/qunlong/first/inspection/batchSetPriority', list)
        .then(res => {
          this.yt.isShowEditDialog = false;
          this.yt.editObj.loading = false;
          this.yt.get();
          this.$message.success(this.$t(res.msg));
        })
        .catch(e => {
          this.yt.editObj.loading = false;
          this.utils.errorMessage(e);
        });
    },

    getAdaptMould() {
      //获取机模配磨具
      let params = {};
      this.adaptMoulds = [];
      params.materialId = this.yt.editObj.materialId;
      params.pageSize = 999;
      this.http
        .get('/web/basic/mould/adaptMould', {
          params: params
        })
        .then(res => {
          this.adaptMoulds = res.data.rows;
        })
        .catch(err => {
          this.utils.errorMessage(err);
        });
    },
    getAdaptEquipment() {
      //获取机模配机器
      let params = {};
      params.materialId = this.yt.editObj.materialId;
      params.mouldId = this.yt.editObj.mouldId;
      params.pageSize = 999;

      this.http
        .get('/web/equipment/adaptEquipmentAllot', {
          params: params
        })
        .then(res => {
          this.adaptEqs = res.data.rows;
        })
        .catch(err => {
          this.utils.errorMessage(err);
        });
    },

    resetAdapData() {
      this.adaptEqs = [];
      this.adaptMoulds = [];
      setTimeout(() => {
        console.log(111);
        this.$refs.eqCS.showDialog(true);
        console.log(222);
      }, 300);
    },

    runSyncQunlongWorkOrdersJob() {
      this.$confirm(this.$t('shifoulijikaishitongbupaigongdan'), this.$t('WARNING'), {
        confirmButtonText: this.$t('queding'),
        cancelButtonText: this.$t('quxiao'),
        confirmButtonClass: 'el-button--danger',
        type: 'warning'
      })
        .then(() => {
          this.http.post('/custom/qunlong/work/orders/runSyncQunlongWorkOrdersJob').then(res => {
            this.$message.success(this.$t('kaishirenwuchenggong'));
          });
        })
        .catch(e => {
          console.log(e);
          this.$message({
            type: 'info',
            message: this.$t('yiquxiao')
          });
        });
    },
    //ids，items如果是多选会是数组
    async beforeSave(ids, items) {
      console.log(items);
      let params = {
        woIds: ids
      };
      console.log(this);
      try {
        let result = await this.http.post('/custom/qunlong/batchAllotValidated', params);

        this.$set(this.yt.editObj, 'equipmentId', result.data.equipmentId);
        this.$set(this.yt.editObj, 'planQuantity', result.data.planQuantity);
        this.$set(this.yt.editObj, 'leftProductionQuantity', result.data.leftProductionQuantity);
        this.$set(this.yt.editObj, 'materialId', result.data.materialId);
        this.$set(this.yt.editObj, 'mouldId', result.data.mouldId);
        this.$set(this.yt.editObj, 'materialStr', items[0].material.code + '|' + items[0].material.name);
        this.$set(this.yt.editObj, 'woIds', result.data.woIds);

        this.getAdaptMould();
        this.getAdaptEquipment();

        return true;
      } catch (error) {
        this.utils.errorMessage(error);
        return false;
      }
      return true;
    },

    syncWoReportByApi() {
      this.zhongshuoSapLoading = true;
      this.http
        .post('/custom/zhongshuo/plan/syncWoReportByApi')
        .then(res => {
          if (res.data) {
            this.$message.success(this.$t('diaoyongSAPbaogongjiekouchenggong'));
            this.zhongshuoSapLoading = false;
            this.yt.get();
          } else {
            this.$message.error(this.$t('diaoyongSAPbaogongjiekoushibai'));
            this.zhongshuoSapLoading = false;
          }
        })
        .catch(err => {
          this.utils.errorMessage(err);
        })
        .finally(() => {
          this.zhongshuoSapLoading = false;
        });
    },
    printLabel(wo) {
      this.printObj = this.utils.copy(wo);
      this.http.get('/web/production/woreportrecord/page?pageNum=1&pageSize=1&woId=' + this.printObj.id).then(res => {
        this.$set(this.printObj, 'operator', res.data.rows[0].createByObject.nickname);
      });
      let params2 = { orgId: this.printObj.orgId };
      this.http.get('/web/equipment/getShiftDateByOrgId?' + this.qs.stringify(params2)).then(res => {
        this.$set(this.printObj, 'batchNumber', res.data);
        this.$set(this.printObj, 'produceDate', res.data);
      });

      this.$set(this.printObj, 'shengchanpici', this.dayjs(this.printObj.actualStartTime).format('YYYYMMDD'));

      this.isPrint = false;
      this.isShowPrintDialog = true;
    },
    closePrintDialog() {
      this.isShowPrintDialog = false;
      this.isShowQrCode = false;
    },
    dayin() {
      this.isPrint = true;
      setTimeout(() => {
        let domSrc = document.getElementById('printContent');
        html2canvas(domSrc).then(canvas => {
          const imgData = canvas.toDataURL('image/png');
          print({
            printable: imgData,
            type: 'image',
            documentTitle: '',
            modalMessage: this.$t('zhengzaijiazaiwenjian,qingshaohou')
          });
          // this.closePrintDialog();
        });
      }, 50);
    },
    dayin2() {
      var raw = JSON.stringify({
        AbsolutePath: 'c:\\inetpub\\wwwroot\\BarTender\\wwwroot\\Templates\\Yizumi\\hzvode\\gongdanbiaoqian.btw',
        Printer: 'PDF',

        Copies: 1,
        NamedDataSources: {
          name: 'Seattle, WA'
        }
      });
      this.http
        .post('http://.0.0.1/BarTender/api/v1/print', raw)
        .then(response => response.text())
        .then(result => console.log(result))
        .catch(error => console.log('error', error));
    },
    printRuikeLabel(wo) {
      //打印前置校验
      this.http
        .get('/web/production/wo/printValidate?woId=' + wo.id)
        .then(res => {
          this.ruikePrintObj = this.utils.copy(wo);
          this.isShowRuikePrintLabel = true;
        })
        .catch(err => {
          this.utils.errorMessage(err);
        });
    },
    closeRuikePrintLabel() {
      this.isShowRuikePrintLabel = false;
    },
    urgent(wo) {
      wo.urgent = true;
      this.loading = true;
      this.http
        .post('/web/production/wo/update', wo)
        .then(res => {
          this.loading = false;
          this.yt.get();
          this.$message.success(this.$t(res.msg));
        })
        .catch(error => {
          this.$message.error(this.$t(error));
          this.loading = false;
        });
    },
    cancelUrgent(wo) {
      wo.urgent = false;
      this.loading = true;
      this.http
        .post('/web/production/wo/update', wo)
        .then(res => {
          this.loading = false;
          this.yt.get();
          this.$message.success(this.$t(res.msg));
        })
        .catch(error => {
          this.$message.error(this.$t(error));
          this.loading = false;
        });
    },
    standardPrintLabel(wo) {
      this.printObj = this.utils.copy(wo);
      this.isShowStandardPrintLabel = true;
    },
    weierPrintLabel(wo) {
      this.printObj = this.utils.copy(wo);
      this.isShowWeierPrintLabel = true;
    },
    litenghuiPrintLabel(wo) {
      this.http.get('/web/production/wo/printValidate?woId=' + wo.id).then(res => {
        this.printObj = this.utils.copy(wo);
        this.isShowLitenghuiPrintLabel = true;
      }).catch(err => {
        this.utils.errorMessage(err);
      });
    },
    closeStandardPrintLabel() {
      this.isShowStandardPrintLabel = false;
    },
    closeWeierPrintLabel() {
      this.isShowWeierPrintLabel = false;
    },
    closeLitenghuiPrintLabel() {
      this.isShowLitenghuiPrintLabel = false;
    },
    weierAdaptTool(wo) {
      this.$set(this, 'material', wo.material);
      this.isShowWeierAdaptTool = true;
    },
    childWoCheck(row) {
      let params = {};
      params.id = row.id;
      this.loading = true;
      this.http.post('/web/production/wo/check', params).then(res => {
        this.loading = false;
        if (res.data == true) {
          this.childStart(row);
        } else {
          this.$confirm(this.$t('cunzaizantinggongdandetishi'), this.$t('tishi'), {
            confirmButtonText: this.$t('rengjixukaishi'),
            cancelButtonText: this.$t('quxiaokaishi'),
            type: 'warning'
          }).then(() => {
            this.childStart(row);
          }).catch(() => { });
        }
      }).catch(err => {
        this.loading = false;
        this.utils.errorMessage(err);
      });
    },
    childStart(row) {
      this.http.post('/web/production/wo/childStart', row.id).then(res => {
        this.yt.get();
        this.$message.success(this.$t(res.msg));
      }).catch(error => {
        this.$message.error(this.$t(error));
      });
    },
    childStop(row) {
      this.$set(row, 'stopLoading', true);
      this.http.post('/web/production/wo/childStopCheck', row.id).then(res => {
        if (res.data && res.data > 0) {
          this.$confirm(this.$t('dqkhmcs') + res.data + ',' + this.$t('qqrsfjxzt') + '?', this.$t('tishi'), {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.http.post('/web/production/wo/childStop', row.id).then(res => {
              this.yt.get();
              this.$message.success(this.$t(res.msg));
            }).catch(error => {
              this.$message.error(this.$t(error));
            });
          });
        } else {
          this.http.post('/web/production/wo/childStop', row.id).then(res => {
            this.yt.get();
            this.$message.success(this.$t(res.msg));
          }).catch(error => {
            this.$message.error(this.$t(error));
          });
        }
      }).catch(error => {
        this.$message.error(this.$t(error));
      }).finally(() => {
        this.$set(row, 'stopLoading', false);
      });
    },
  }
};
</script>
